import Datatable from "../../Components/Datatable"
import { useTranslation } from "react-i18next";
import React, { useState, useEffect } from "react";
import axios from "axios";
import { useAuth } from '../../../../../context/AuthContext';
import Swal from 'sweetalert2'
import { API_BASE_URL } from "../../../../../Helpers/apiConfig";

const formatDate = (isoString) => {
    if (!isoString) return "-";
    const date = new Date(isoString);
    if (isNaN(date.getTime())) return isoString;
    return date.toLocaleString("tr-TR", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit"
    });
};

const TYPE_META = {
    "deposit-inv": { label: "Bireysel İlk Satın Alma", badgeClass: "bg-success" },
    "extend-inv": { label: "Bireysel Uzatma", badgeClass: "bg-primary" },
    "deposit-co": { label: "Kurumsal İlk Satın Alma", badgeClass: "bg-danger" },
    "extend-co": { label: "Kurumsal Uzatma", badgeClass: "bg-warning text-dark" },
};

export const AdminPaymentRequests = () => {
    const { user } = useAuth();
    const [msg, setMsg] = useState([]);
    const [loading, setLoading] = useState(true);
    const { t } = useTranslation()
    const [data, setData] = useState([]);
    const [banks, setBanks] = useState([]);
    const [packages, setPackages] = useState([]);

    const columns = React.useMemo(
        () => [
            {
                Header: t("paymentmethod"),
                Footer: t("paymentmethod"),
                accessor: 'paymentInfo',
            },
            {
                Header: t("packageName"),
                Footer: t("packageName"),
                accessor: 'packageInfo',
            },
            {
                Header: t("paymentrequesttype"),
                Footer: t("paymentrequesttype"),
                accessor: (originalRow) => (
                    <span className={`badge ${TYPE_META[originalRow.type]?.badgeClass || "bg-secondary"}`}>
                        {originalRow.station}
                    </span>
                ),
                id: 'station',
                Footer: t("paymentrequesttype"),
            },
            {
                Header: t("paymentStatus"),
                Footer: t("paymentStatus"),
                accessor: 'status',
            },
            {
                Header: t("transactionDate"),
                Footer: t("transactionDate"),
                accessor: 'transactionDate',
            },
            {
                Header: t("userEmail"),
                Footer: t("userEmail"),
                accessor: 'username',
            },
            {
                Header: t("namesurname"),
                Footer: t("namesurname"),
                accessor: 'userFullName',
            },
            {
                Header: t("edit"),
                accessor: (originalRow) => (
                    <div className="d-flex align-items-center">
                        <button
                            className="btn btn-warning mr-2 btn-sm"
                            onClick={() => handleEdit(originalRow)}
                        >
                            {t("edit")}
                        </button>
                    </div>
                ),
                id: 'actionEdit',
                Footer: t("edit"),
            },
            {
                Header: t("rejectTransaction"),
                accessor: (originalRow) => (
                    <div className="d-flex align-items-center">
                        <textarea id={"cancelnote" + originalRow['id']} placeholder="note" required />
                        <button
                            className="btn btn-danger btn-sm"
                            onClick={() => handleDelete(originalRow)}
                        >
                            {t("cancel")}
                        </button>
                    </div>
                ),
                id: 'actionDelete',
                Footer: t("rejectTransaction"),
            },
        ],
        [],
    )

    const handleEdit = (row) => {
        window.location.href = "/admin/editpayment/" + row['id'] + "/" + row['type'];
    }

    const handleDelete = async (row) => {
        let cancelNote = document.getElementById('cancelnote' + row['id']).value;
        try {
            const headerss = {
                "accept": "*/*",
                'Content-Type': 'application/json',
                'Access-Control-Allow-Credentials': 'false',
                'Authorization': 'Bearer ' + user.token
            }
            await axios({
                method: 'Get',
                url: API_BASE_URL + "/admin/Subscription/Reject",
                params: {
                    transactionId: row['id'],
                    note: cancelNote,
                },
                headers: headerss
            }).then(res => {
                if (res.status === 200) {
                    if (res.data['success']) {
                        Swal.fire({
                            title: "Başarılı!",
                            icon: "success",
                            confirmButtonText: `Tamam`
                        });
                    }
                    else {
                        Swal.fire({
                            title: res.data['message'],
                            icon: "error",
                            confirmButtonText: `Tamam`
                        });
                        setMsg(res.data['message']);
                    }
                }
                else {
                    Swal.fire({
                        title: "Silinirken hata ile karşılaşıldı!",
                        icon: "error",
                        confirmButtonText: `Tamam`
                    });
                    setMsg("Beklenmedik Bir Hata Oluştu. Tekrar Deneyiniz.");
                }
            });
        } catch (err) {
            setMsg(err?.message || "Bir hata oluştu");
        }

        window.location.reload();
    }

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            try {
                const headerss = {
                    "accept": "*/*",
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Credentials': 'false',
                    'Authorization': 'Bearer ' + user.token
                }

                const banksRes = await axios({
                    method: 'GET',
                    url: API_BASE_URL + "/admin/Gateway/GetList",
                    headers: headerss
                });
                let localBanks = [];
                if (banksRes.status === 200 && banksRes.data['success']) {
                    localBanks = banksRes.data['data'].map(dt => ({
                        id: dt['id'],
                        gatewayName: dt['gatewayName'],
                        typeName: dt['typeName'],
                    }));
                    setBanks(localBanks);
                }

                const packagesRes = await axios({
                    method: 'GET',
                    url: API_BASE_URL + "/admin/Package/GetList",
                    headers: headerss
                });
                let localPackages = [];
                if (packagesRes.status === 200 && packagesRes.data['success']) {
                    localPackages = packagesRes.data['data'].map(dt => ({
                        id: dt['id'],
                        packageName: dt['packageName'],
                    }));
                    setPackages(localPackages);
                }

                const awaitingRes = await axios({
                    method: 'GET',
                    url: API_BASE_URL + "/admin/Subscription/GetAwaiting",
                    headers: headerss
                });

                if (awaitingRes.status === 200 && awaitingRes.data['success']) {
                    const rows = [];
                    for (let i = 0; i < awaitingRes.data['data'].length; i++) {
                        const item = awaitingRes.data['data'][i];
                        const type = item['transaction']['type'];
                        const station = TYPE_META[type]?.label || type;

                        let paymentInfo = "";
                        const bank = localBanks.find(b => b.id === item['transaction']['gatewayId']);
                        paymentInfo = bank ? bank.gatewayName : (item['transaction']['gatewayId'] ?? "-");

                        let packageInfo = "";
                        const pkg = localPackages.find(p => p.id === item['transaction']['package']);
                        packageInfo = pkg ? pkg.packageName : item['transaction']['package'];

                        let status = "";
                        if (item['transaction']['status'] === "requested") status = t('requested');
                        else if (item['transaction']['status'] === "approved") status = t('approved');
                        else if (item['transaction']['status'] === "rejected") status = t('rejected');

                        rows.push({
                            "id": item['transaction']['id'],
                            "paymentInfo": paymentInfo,
                            "packageInfo": packageInfo,
                            "station": station,
                            "type": type,
                            "status": status,
                            "transactionDate": formatDate(item['transaction']['transactionDate']),
                            "username": item['username'],
                            "userFullName": item['userFullName'],
                        });
                    }
                    setData(rows);
                } else {
                    setMsg(awaitingRes.data['message']);
                }
            } catch (err) {
                setMsg(err.message);
            }
            setLoading(false);
        }
        fetchData();
    }, []);

    return (
        <div>
            <div style={{ textAlign: "center" }}>
                <br />
                <h1>Ödeme Talepleri</h1>
                <h4> {msg} </h4>
                {loading && <div>Veriler yükleniyor...</div>}
                {!loading && (
                    <div>
                        <Datatable data={data} columns={columns} tableBaslik={t('waintingpaymentrequests')} />
                    </div>
                )}
            </div>
        </div>
    )
}
export default AdminPaymentRequests;
